export default __webpack_public_path__ + "static/media/Close.201274d6.svg";